const COUNTRIES = {
  GB: "GB",
  IE: "IE",
};

export default COUNTRIES;
